export default __webpack_public_path__ + "media/mobile_top_bg.806bba28.jpg";